import React, { memo } from 'react';
import { Box, CircularProgress, useMediaQuery, useTheme } from '@mui/material';

interface NerdSpinnerProps {
  size?: number;
  /** Render centered within the full available space instead of inline. */
  fullPage?: boolean;
}

/** Sentinel's branded spinner, ported from ai4swe-secops-app's NerdSpinner (message/timer stripped — visual only). */
const NerdSpinner: React.FC<NerdSpinnerProps> = ({ size, fullPage = false }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));

  const responsiveSize = size || (isMobile ? 44 : isTablet ? 56 : 64);

  const spinner = (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: responsiveSize * 0.5,
        height: responsiveSize * 0.5,
        borderRadius: '50%',
        bgcolor: 'text.primary',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: responsiveSize * 0.2,
        fontWeight: 700,
        fontFamily: 'Poppins, sans-serif',
        color: 'background.default',
        letterSpacing: -0.5,
      }}>
        SEN
      </Box>
      <CircularProgress size={responsiveSize} />
    </Box>
  );

  if (!fullPage) return spinner;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%', flex: 1 }}>
      {spinner}
    </Box>
  );
};

export default memo(NerdSpinner);
